import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import AuditConstants from "../Constants/AuditConstants";

class Audit_Action {
  getOperationAudit(searchField) {
    httpRequest(
      config.webServiceURL + "/Audit/GetOperationAudit",
      "POST",
      JSON.stringify({
        PlantId: searchField.PlantId,
        UserId: searchField.UserId,
        OperationId: searchField.OperationId,
        FromDate: searchField.FromDate,
        ToDate: searchField.ToDate,
        AuditForId: searchField.AuditForId,
        Token: searchField.Token,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: AuditConstants.GET_OPERATION_AUDIT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: AuditConstants.GET_OPERATION_AUDIT_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getOperationAuditLog(userID) {
    httpRequest(
      config.webServiceURL + "/Audit/GetOperationLogs/" + userID,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: AuditConstants.GET_OPERATION_AUDIT_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: AuditConstants.GET_OPERATION_AUDIT_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getFieldLog(auditObjectID, fieldID) {
    httpRequest(
      config.webServiceURL +
        "/Audit/GetFieldLogs/" +
        auditObjectID +
        "/" +
        fieldID,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: AuditConstants.GET_AUDIT_FIELD_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: AuditConstants.GET_AUDIT_FIELD_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getObjectLog(auditObjectID) {
    httpRequest(
      config.webServiceURL + "/Audit/GetObjectLogs/" + auditObjectID,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: AuditConstants.GET_AUDIT_OBJECT_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: AuditConstants.GET_AUDIT_OBJECT_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getSearchField() {
    httpRequest(
      config.webServiceURL + "/Audit/GetSearchFormFields",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: AuditConstants.GET_SEARCH_FIELD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: AuditConstants.GET_SEARCH_FIELD_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new Audit_Action();
